module.exports = __webpack_public_path__ + "img/camp2.322a0b17.png";